__turbopack_context__.v({
  "disabled": "Label-module__iuFsmW__disabled",
  "label": "Label-module__iuFsmW__label",
  "required": "Label-module__iuFsmW__required",
  "srOnly": "Label-module__iuFsmW__srOnly",
});
